import React from 'react';

import ExpansionPanel, {ExpansionPanelDetails, ExpansionPanelSummary,} from 'material-ui/ExpansionPanel';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import Typography from 'material-ui/Typography';

import Button from 'material-ui/Button';

import Input, {InputAdornment, InputLabel} from 'material-ui/Input';
import TextField from 'material-ui/TextField';
import {MenuItem} from 'material-ui/Menu';
import {FormHelperText, FormControl} from 'material-ui/Form';
import Select from 'material-ui/Select';
import Radio, {RadioGroup} from 'material-ui/Radio';
import {FormControlLabel} from 'material-ui/Form';

import { DatePicker } from 'material-ui-pickers';

import Grid from 'material-ui/Grid';

import {FilterList, ArrowDownward, ArrowUpward} from 'material-ui-icons';

import tsl from '../../tsl';

import axios from 'axios';

export default class Filter extends React.Component {
	
	state = {
		statuses: [],
		aircrafts: [],
		filters: {
			status: [],
			aircraft: [],
			date: null,
			orderBy: 'id',
			order: 'desc'	// desc / asc
		},
		filter_displayed: false,
	};

	componentWillReceiveProps = (newProps) => {
		// this.setState({ filters: newProps.filter });
	};

	componentDidMount() {
		axios.get('/api/operator/requests/statuses')
			.then((res) => {
				// predefine filter of statuses
				const status = res.data
					.filter(status => (status.name !== 'declined'))	// filter to all statuses except name=CANCELED
					.map(status => status.id);	// convert array of object to array of it's IDs

				const filters = {
					...this.state.filters,
					status
				};

				this.setState({
					statuses: res.data,
					filters
				});

				this.propagateChanges(filters);
			});

		axios.get('/api/operator/aircraft/models')
			.then((res) => { 
				this.setState({ aircrafts: res.data.data })
			})
	}

	propagateChanges = (filter) => {
		this.props.onChange(filter);
		// console.log('filter state',this.state.filters);
	};

	filterChange = (name) => (e) => {
		const eventTarget = e.target;

		this.setState(state => ({
			filters: {
				...state.filters,
				[name]: eventTarget.value
			}
		}), () => {
			this.propagateChanges(this.state.filters);
		});
	};

	handleDateChange = (name) => (value) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				[name]: value ? value.format("YYYY-MM-DD") : null
			}
		}), () => {
			this.propagateChanges(this.state.filters);
		});
	};

	handleDateClear = (name) => () => {
		this.handleDateChange(name)(null);
	};

	/*
	orderBy = (column) => () => {
		this.setState({ 
			orderBy: column,
			// change order if the filter is already at this column
			orderDesc: (this.state.orderBy == column) ? !this.state.orderDesc : this.state.orderDesc
		});
	}*/

	filterCollapse = () => {
		this.setState({
			filter_displayed: !this.state.filter_displayed
		});
	}

	render() {
		return (
			<ExpansionPanel expanded={this.state.filter_displayed} onChange={this.filterCollapse}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                	<FilterList />
                    <Typography>{tsl('flights.filter.header')}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>

	            	<Grid container spacing={8}>
	            		{/* 
	            		<Grid item sm={3} xs={12}>
		                    <Button onClick={this.orderBy('time')}>
								{tsl('flights.filter.time_sort_btn')}
								{this.state.orderBy == 'time'? (this.state.orderDesc ? <ArrowDownward /> : <ArrowUpward />) : ''}
		                    </Button>
		                </Grid>
		            	*/}

		                <Grid item sm={4} xs={12}>
		                    <FormControl fullWidth >
		                      <InputLabel htmlFor="status">{tsl('flights.filter.by_status')}</InputLabel>
		                      <Select
		                        name="status"
		                        multiple
		                        value={this.state.filters.status || []}
		                        onChange={this.filterChange('status')}
		                      >
		                        {this.state.statuses.map((status) => {
		                            return (<MenuItem key={status.id} value={status.id}>{status.title}</MenuItem>);
		                        })}
		                      </Select>
		                    </FormControl>
		                </Grid>

										<Grid item sm={4} xs={12}>
		                    <FormControl fullWidth >
		                      <InputLabel htmlFor="flight_type">{tsl('flights.filter.by_aircraft')}</InputLabel>
		                      <Select
		                        name="aircraft"
		                        multiple
		                        value={this.state.filters.aircraft || []}
		                        onChange={this.filterChange('aircraft')}
		                      >
														{this.state.aircrafts.map((aircraft) => {
		                            return (<MenuItem key={aircraft.id} value={aircraft.id}>{aircraft.name}</MenuItem>);
		                        })}
		                      </Select>
		                    </FormControl>
		                </Grid>

		                <Grid item sm={4} xs={12}>
	                		<DatePicker
	                			fullWidth
	                			label={tsl('flights.filter.date')}
	                			format="LL"
				                value={this.state.filters.date || null}
				                onChange={this.handleDateChange('date')}
				                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
				                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
				                invalidLabel=""
	                		 />
	                		 {this.state.filters.date
	                		 	? <Button 
		                		 		className="w-100"
		                		 		onClick={this.handleDateClear('date')}
	                		 		>
	                		 			{tsl('flights.filter.date_clear')}
	                		 		</Button>
	                		 	: ''
	                		 }
		                </Grid>

		                <Grid item sm={4} xs={12}>
		                	<RadioGroup
					            aria-label="order"
					            name="order"
					            value={this.state.filters.order}
					            onChange={this.filterChange('order')}
					            className="d-flex flex-row"
					         >
					            <FormControlLabel 
					            	value="desc" 
					            	control={<Radio />} 
					            	label={<i className="zmdi zmdi-sort-amount-desc zmdi-hc-2x"></i>}
					            />
					            <FormControlLabel
					            	value="asc"
					            	control={<Radio />}
					            	label={<i className="zmdi zmdi-sort-amount-asc zmdi-hc-2x"></i>}
					            />
					        </RadioGroup>

		                </Grid>

	            	</Grid>

	            </ExpansionPanelDetails>

            </ExpansionPanel>
		);
	}
}


// WEBPACK FOOTER //
// ./app/used/requests/Filter.js